import '../scss/style.scss';
import { initAll } from 'govuk-frontend';
initAll();

import feed from './feed/feed.index';
import ui from './ui/ui.index';
import jobs from './jobs-feed/jobs.feed.pagination';

const init = () => {
	document.addEventListener('DOMContentLoaded', () => {
		feed.init();
		ui();
		jobs();
	});
};

init();
